import Stack from "@mui/material/Stack";
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import { Typography } from "@mui/material";
import { useTranslation } from "react-i18next";

import ClientForm from "./ClientForm";

function ClientEdit({ client }) {

    const { t } = useTranslation();

    return (
        <Stack spacing={3}>
            <Card>
                <CardContent>
                    <Stack spacing={2}>
                        <Typography variant="h6" color="primary">
                            {t("General")}
                        </Typography>
                        <ClientForm
                            client={client}
                        />
                    </Stack>
                </CardContent>
            </Card>

        </Stack>
    );
}

export default ClientEdit;
